import Vue from 'vue';
import axios from 'axios';

export async function FetchChildRewards({ commit }, childId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/rewards/`,
  })
    .then((response) => {
      commit('setChildRewards', { id: childId, data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function ClaimRewards({ commit }, rewardId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/child_reward/${rewardId}/claim/`,
  })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function DeleteReward({ commit }, rewardId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'DELETE',
    url: `/child_reward/${rewardId}/`,
  })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function CreateReward({ commit }, payload) {
  let to_return = '';
  await Vue.axios
    .post('/child_reward/', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      console.log('response', response);
      to_return = 'correct';
    })
    .catch((error) => {
      to_return = 'error ' + error.mesage;
      commit('error', error);
    });
  return to_return;
}

export async function EditReward({ commit }, payload) {
  let to_return = '';
  await Vue.axios
    .patch('/child_reward/' + payload.get('id') + '/', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      console.log('response', response);
      to_return = 'correct';
    })
    .catch((error) => {
      to_return = 'error ' + error.mesage;
      commit('error', error);
    });
  return to_return;
}

export async function FetchParentRewards({ commit }, parentId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${parentId}/rewards/`,
  })
    .then((response) => {
      commit('setParentRewards', { id: parentId, data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function ClaimParentRewards({ commit }, rewardId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent_reward/${rewardId}/claim/`,
  })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function DeleteParentReward({ commit }, rewardId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'DELETE',
    url: `/parent_reward/${rewardId}/`,
  })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function CreateParentReward({ commit }, payload) {
  let to_return = '';
  await Vue.axios
    .post('/parent_reward/', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      console.log('response', response);
      to_return = 'correct';
    })
    .catch((error) => {
      to_return = 'error ' + error.mesage;
      commit('error', error);
    });
  return to_return;
}

export async function EditParentReward({ commit }, payload) {
  let to_return = '';
  await Vue.axios
    .patch('/parent_reward/' + payload.get('id') + '/', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      console.log('response', response);
      to_return = 'correct';
    })
    .catch((error) => {
      to_return = 'error ' + error.mesage;
      commit('error', error);
    });
  return to_return;
}

export async function fetchRewardsIdeas({ commit }) {
  try {
    const { data } = await axios.get('/bank_reward/');
    commit('setRewardIdeas', data);
  } catch (error) {
    throw new Error('Error when trying to fetch the bank of the reward ideas');
  }
}
